const facilitiesAuthRoute = createApiRoute(ApiModule.AUTH, ApiDataModel.FACILITIES)

export const apiProductionUnits = {
	fetchProductionUnits: async (filters?: { name?: string; type?: string }): Promise<IProductionUnitListItem[]> => {
		const { data } = await apiCommon<IFacility[]>(facilitiesAuthRoute, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, {
				'filters[name]': filters?.name,
				'filters[type]': filters?.type,
			}),
		})

		return mapFacilitiesToProductionUnits(data)
	},

	fetchDeliveryPickupPoints: async (): Promise<IWarehousePickupLocation[]> => {
		const response = await apiCommon<IWarehousePickupLocation[]>('api/employee/delivery/pickup-points', {
			method: 'GET',
		})

		if (Array.isArray(response)) {
			return response
		}

		return Array.isArray(response.data) ? response.data : []
	},

	fetchDeliveryRegions: async (): Promise<IDeliveryRegions[]> => {
		const response = await apiCommon<IDeliveryRegions[]>('api/employee/delivery/regions', {
			method: 'GET',
		})

		if (Array.isArray(response)) {
			return response
		}

		return Array.isArray(response.data) ? response.data : []
	},

	fetchDeliveryForwarders: async (): Promise<IDeliveryForwarders[]> => {
		const response = await apiCommon<IDeliveryForwarders[]>('api/employee/delivery/forwarders', {
			method: 'GET',
		})

		if (Array.isArray(response)) {
			return response
		}

		return Array.isArray(response.data) ? response.data : []
	},
}
